import { useMemo } from "react";
import { useGetList } from "react-admin";
import { Reimbursement, ResourceName } from "@/types";

/** Reimbursements linked to one stop-loss claim (`stoploss_claim_id_ref`, the #5359 filter). */
export const useClaimReimbursements = (claimId: string | undefined, perPage = 100) => {
  const { data, total, isLoading, error, refetch } = useGetList<Reimbursement>(
    ResourceName.REIMBURSEMENTS,
    {
      filter: { stoploss_claim_id_ref: claimId },
      pagination: { page: 1, perPage },
      sort: { field: "check_date", order: "DESC" },
    },
    { enabled: !!claimId }
  );
  const reimbursements = useMemo(() => data ?? [], [data]);
  // "Reimbursed so far" counts money that has arrived: status paid only. Pending,
  // approved and denied rows are listed on the tab but do not reduce the
  // outstanding figure (calc-expert review, 2026-10-23).
  const reimbursedTotal = useMemo(
    () =>
      reimbursements.reduce(
        (sum, r) =>
          r.status === "paid" ? sum + (typeof r.reimbursement_amount === "number" ? r.reimbursement_amount : 0) : sum,
        0
      ),
    [reimbursements]
  );
  return { reimbursements, total: total ?? reimbursements.length, reimbursedTotal, isLoading, error: !!error, refetch };
};
